class FixedNavsHandler {
    items: Array<HTMLElement>;

    constructor(items: Array<HTMLElement>) {
        this.items = items;
        this.setHeightProperties();
    }

    setHeightProperties() {
        let activeHeight = 0;

        this.items.forEach(item => {
            activeHeight = Math.max(activeHeight, item.offsetHeight);
        });

        document.documentElement.style.setProperty('--nav-clearance', `${activeHeight}px`);
    }
}

let FixedHeaders: FixedNavsHandler;
const fixedItems = [].slice.call(document.querySelectorAll('[data-fixed-header]')) as Array<HTMLElement>;
if (fixedItems) {
    FixedHeaders = new FixedNavsHandler(fixedItems);
}

export { FixedHeaders };